module.exports = __webpack_public_path__ + "static/media/GDb180sbMAANB6D.56283b3d.webp";